'use client';

import type { CSSProperties, ReactNode } from 'react';

import { AnalyticEvents } from '@ps/analytics';
import type { popstore } from '@ps/types';

// Fires popstore_bio_link_clicked for any click inside a bio button, as PopshopRN's custom-button container did.
export function TrackLinkClick({
  track,
  button,
  creatorId,
  creatorUrlCode,
  className,
  style,
  children,
}: {
  track: boolean;
  button: popstore.CustomButton;
  creatorId: string;
  creatorUrlCode: string;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}) {
  const onClickCapture = () => {
    AnalyticEvents.default.popstoreBioLinkClicked(
      {
        ctaType: 'link',
        ctaTitle: button.title?.value,
        ctaObjectId: button.id,
        buttonType: button.type as 'text',
        buttonUrl: button.link || button.internalLink?.linkedNode.fullPath,
        creatorId,
        creatorUrlCode,
      },
      {
        buttonLinkType: button.internalLink ? 'internal' : 'external',
        shortcutName: button.internalLink?.shortcutName,
      },
    );
  };

  return (
    <div
      className={className}
      style={style}
      onClickCapture={track ? onClickCapture : undefined}
    >
      {children}
    </div>
  );
}
